import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddCommentsComponent } from "./add-comments/add-comments.component";
import { FinalReportComponent } from "./reports/final-report/final-report.component";
import { PeerReviewCommentsSummaryComponent } from "./reports/peer-review-comments-summary/peer-review-comments-summary.component";
import { ReviewCommentsComponent } from "./review-comments/review-comments.component";
import { ReviewImpactComponent } from "./review-impact/review-impact.component";
import { ReviewListComponent } from "./review-list/review-list.component";
import { ReviewResponseComponent } from "./review-response/review-response.component";
import { ReviewStatusComponent } from "./review-status/review-status.component";
import { DashboardComponent } from './dashboard/dashboard.component';

export const peereviewRoutes: Routes = [
    { path: 'review-list', component: ReviewListComponent, data: { title: 'PEER REVIEW', isProjectCodeRequired: true }} ,
    { path: 'review-status', component: ReviewStatusComponent, data: { title: 'PEER REVIEW', isProjectCodeRequired: true }} ,
    { path: 'review-comments', component: ReviewCommentsComponent, data: { title: 'PEER REVIEW', isProjectCodeRequired: true }} ,
    { path: 'review-response', component: ReviewResponseComponent, data: { title: 'PEER REVIEW', isProjectCodeRequired: true }},
    { path: 'review-impacts', component: ReviewImpactComponent, data: { title: 'PEER REVIEW', isProjectCodeRequired: true }},
    { path: 'review-add-comments', component: AddCommentsComponent, data: { title: 'PEER REVIEW', isProjectCodeRequired: false }},
    { path: 'final-report',component: FinalReportComponent, data: { title: 'FINAL REPORT', isProjectCodeRequired: false }},
    { path: 'dashboard',component: DashboardComponent, data: { title: 'DASHBOARD', isProjectCodeRequired: false }},
    { path: 'comments-summary', component: PeerReviewCommentsSummaryComponent, data: {title:'COMMENTS SUMMARY REPORT', isProjectCodeRequired: false}}
];

@NgModule({
    imports: [RouterModule.forChild(peereviewRoutes)],
    exports: [RouterModule]
})


export class PeereviewRoutingModule { }